module.exports = __webpack_public_path__ + "static/img/unit_bg_all2.29297031.jpg";